export default __webpack_public_path__ + "static/media/neraca2.364f3341.png";